import { type ReactNode, useCallback, useLayoutEffect, useMemo } from "react";
import { IdentityApiSdk } from "@packsize/identity-api-sdk";

import { useToken } from "../../hooks";

import { IdentityClientContext } from "./identity-client.context";

interface IdentityClientProviderProps {
	children: ReactNode;
	identityBaseRoute: string;
}

export const IdentityClientProvider: React.FC<IdentityClientProviderProps> = ({ children, identityBaseRoute }) => {
	const { token, tokenValid } = useToken();

	const client = useMemo(() => {
		const client = new IdentityApiSdk();

		client.setSdkRootUrl(identityBaseRoute);

		return client;
	}, [identityBaseRoute]);

	useLayoutEffect(() => {
		if (token && tokenValid) {
			client.setSdkAuthenticationToken(token);
			return;
		}

		client.setSdkAuthenticationToken("");
	}, [client, token, tokenValid]);

	const createClient = useCallback(
		(clientToken: string) => new IdentityApiSdk(clientToken, identityBaseRoute),
		[identityBaseRoute],
	);

	const value = useMemo(() => ({ client, createClient }), [client, createClient]);

	return <IdentityClientContext.Provider value={value}>{children}</IdentityClientContext.Provider>;
};
